<template>
  <div class="top-base" :class="{'has-notification': hasNotification }">
    <hot-tag-list :hot-taglist="hotTaglist" />

    <slider-banner v-if="sliderBannerList.length > 0" :info-banner="sliderBannerList" />

    <daily-tarot :user-profile="userProfile"/>

    <!-- 新着メニュー -->
    <info-banner v-if="infoBannerList.length > 0" :info-banner-list="infoBannerList" />
    <!-- <deluxe-banner /> -->
    <!-- ↑デザインは同じもの -->

    <new-arrival-menus
      parent-page="membertop"
      :section-data="sectionsData.newMenu"
      :is-subscr-enable="isSubscrEnable"
    />
    <!-- ※セクションデータ構造違う。今後含めあとでちゃんと考える -->

    <!-- Today’s Lucky 7 -->
    <menus-section
      :idx-in-page="0"
      :section-data="sectionsData.todaysLucky7"
      @link-click="onLinkClick"
    ></menus-section>

    <!-- 今日のピックアップ: ワンポイント開運レッスン -->
    <menus-section
      :idx-in-page="1"
      :section-data="sectionsData.todaysPickup"
      @link-click="onLinkClick"
    ></menus-section>

    <!-- リンクボタン：新着メニューはこちら -->
    <!-- <sec-button-link
      :no-border="true"
      :button-face="!!linkbtnData[0] ? linkbtnData[0].face : ''"
      :link-url="!!linkbtnData[0] ? linkbtnData[0].url : ''"
      @link-click="onLinkClick"
    /> -->

    <!-- リンクバナー：新着メニューはこちら -->
    <!--
    <div v-if="linkbtnData[0]" class="top-base__banner top-base__banner--new">
      <img
        src="/static/img/toppage/banner/new.png"
        :alt="linkbtnData[0].face"
        @click="onLinkClick(linkbtnData[0].url)"
      />
    </div>
    -->


    <!-- 今年の運勢を見てみよう -->
    <menus-section
      :idx-in-page="2"
      :section-data="sectionsData.yearLuck"
      @link-click="onLinkClick"
    ></menus-section>

    <!-- 今週のピックアップ: テキスト -->
    <menus-section
      :idx-in-page="3"
      :section-data="sectionsData.weeklyPickupText"
      @link-click="onLinkClick"
    ></menus-section>

    <!-- 今週のピックアップ: 動画  -->
    <menus-section
      :idx-in-page="4"
      :section-data="sectionsData.weeklyPickupMovie"
      @link-click="onLinkClick"
    ></menus-section>

    <!-- リンクボタン：悩んだ時にはオーダーメイド型占い -->
    <!--
    <sec-button-link
      :no-border="true"
      :button-face="!!linkbtnData[1] ? linkbtnData[1].face : ''"
      :link-url="!!linkbtnData[1] ? linkbtnData[1].url : ''"
      :check-through="true"
      @link-click="onLinkClick"
    />
    -->

    <!-- ピックアップ占い師 -->
    <menus-section
      :idx-in-page="5"
      :section-data="sectionsData.pickupCounselor"
      @link-click="onLinkClick"
    ></menus-section>

    <!-- ピックアップ占術 -->
    <menus-section
      :idx-in-page="6"
      :section-data="sectionsData.pickupFortune"
      @link-click="onLinkClick"
    ></menus-section>

    <!-- リンクボタン：月に1本申し込める動画占い -->
    <sec-button-link
      :no-border="true"
      :button-face="!!linkbtnData[2] ? linkbtnData[2].face : ''"
      :link-url="!!linkbtnData[2] ? linkbtnData[2].url : ''"
      @link-click="onLinkClick"
    />

    <!-- タグアイテムループ -->
    <template v-for="(sect, idx) in sectionsData.__tagItems">
      <menus-section
        :idx-in-page="7 + idx"
        :key="idx"
        :section-data="sect"
        @link-click="onLinkClick"
      ></menus-section>
    </template>

    <!-- リンクボタン：今週のランキングはこちら -->
    <sec-button-link
      :no-border="true"
      :button-face="!!linkbtnData[3] ? linkbtnData[3].face : ''"
      :link-url="!!linkbtnData[3] ? linkbtnData[3].url : ''"
      @link-click="onLinkClick"
    />

    <member-tutorial v-if="tutorialShow" @tuto-close="onCloseTutorial" />

  </div>
</template>

<script>
import moment from 'moment'
import {MENU_SEC_TYPES, SEC_ICON_TYPE} from '@/CONSTS/MENUS'
import {FORTUNE_INFO} from '@/CONSTS/FORTUNE_INFO'
import HotTagList from '@/utvStore/components/Toppage/section/HotTagList'
import SliderBanner from '@/utvStore/components/partials/SliderBanner'
import InfoBanner from '@/utvStore/components/partials/InfoBanner'
import DailyTarot from '@/utvStore/components/Toppage/section/DailyTarot'
import Notifications from '@/utvStore/components/partials/Notifications'
import MenusSection from '@/utvStore/components/partials/MenusSection'
import SecButtonLink from '@/utvStore/components/partials/SecButtonLink'
import FixedBackground from '@/utvStore/components/partials/FixedBackground'
import NewArrivalMenus from '@/utvStore/components/Toppage/section/NewArrivalMenus'
import DeluxeBanner from '@/utvStore/components/Toppage/section/DeluxeBanner'
import * as type from '@/utvStore/store/mutation-types'
import {mapState} from 'vuex'
import MemberTutorial from '@/utvStore/components/Toppage/MemberTutorial'
const TUTO_COOKIE_KEY = 'tutorial_already_showed'

export default {
  name: 'MemberTopContents',
  components: {
    NewArrivalMenus,
    MemberTutorial,
    FixedBackground,
    SecButtonLink,
    MenusSection,
    HotTagList,
    Notifications,
    DailyTarot,
    SliderBanner,
    InfoBanner,
    DeluxeBanner,
  },
  data() {
    return {
      sectionsData: {},
      videoSendSrc: {},
      tutorialShow: false,
      // hasNotification: false,
      openNotification: false
    }
  },
  props: {
    receiveSectionsData: {
      type: Object,
      default() {
        return {}
      }
    },
    linkbtnData: {
      type: Array,
      default() {
        return []
      }
    },
    hotTaglist: {
      type: Array,
      default() {
        return []
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    },
    sliderBannerList: {
      type: Array,
      default() {
        return []
      }
    },
    infoBannerList: {
      type: Array,
      default() {
        return []
      }
    },
    isSubscrEnable: {
      type: Boolean,
      require: true,
    },
    hasNotification: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState({
      subscriptVideoData: states => states.item.subscrItems
    }),
  },
  watch: {
    subscriptVideoData: {
      handler() {
      },
      deep: true
    },
  },
  created() {
    //チュートリアルクッキーチェック
    this.checkTutorial()
  },
  mounted() {
    this.setSectionsData(this.receiveSectionsData)
  },
  methods: {
    checkTutorial(){
      const ck = document.cookie
      const regex = new RegExp(`${TUTO_COOKIE_KEY}=(\\d+)`)
      const checkArr = ck.match(regex)
      if(this.userProfile && this.userProfile.subscription){
        const subsc = this.userProfile.subscription
        if((!checkArr || (!!checkArr && !!checkArr[1] && parseInt(checkArr[1]) < 1 ))
          && parseInt(subsc.active) === 1
          && parseInt(subsc.status) === 0
        ){
          this.tutorialShow = true //タイマー等で時間差をつけてもらっても
        }
      }
    },
    onCloseTutorial(){
      this.tutorialShow = false
      this.setTutorialCookie()
    },
    setTutorialCookie(){
      setTimeout(()=>{
        document.cookie = `${TUTO_COOKIE_KEY}=${parseInt(Math.random() * 10000000) + 1}; max-age=${60 * 60 * 24 * 3650}`
      },0)
    },
    setSectionsData: function (rcv) {
      if (rcv != null) {
        this.sectionsData = {}

        //並び順はベタで書く
        // <<< Today’s Lucky 7 >>>
        if (rcv.todaysLucky7 != null) {
          const tgt = rcv.todaysLucky7
          this.sectionsData['todaysLucky7'] = {
            label: 'Today’s Lucky 7',
            tagId: tgt.tagId,
            coloredBg: true,
            type: MENU_SEC_TYPES.todays_lucky7,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['todaysLucky7'].items)
        }

        // <<< 今日のピックアップ >>>
        if (rcv.todaysPickup != null) {
          const tgt = rcv.todaysPickup
          this.sectionsData['todaysPickup'] = {
            label: tgt.label,
            tagId: tgt.tagId,
            subtitle: '今日のピックアップ',
            type: MENU_SEC_TYPES.def_movie,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['todaysPickup'].items)
        }

        // <<< 今年の運勢 >>>
        if (rcv.yearLuck != null) {
          const tgt = rcv.yearLuck
          this.sectionsData['yearLuck'] = {
            label: tgt.label,
            tagId: parseInt(tgt.tagId),
            coloredBg: true,
            subtitle: '1年間の運勢をチェック！',
            type: MENU_SEC_TYPES.def_text,
            itemLimit: 3,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['yearLuck'].items)
        }

        // <<< 今週ピックアップ テキスト >>>
        if (rcv.weeklyPickupText != null) {
          const tgt = rcv.weeklyPickupText
          this.sectionsData['weeklyPickupText'] = {
            label: tgt.label,
            tagId: parseInt(tgt.tagId),
            coloredBg: true,
            subtitle: '今週のピックアップ',
            type: MENU_SEC_TYPES.def_text,
            itemLimit: 3,
            iconType: SEC_ICON_TYPE.text,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['weeklyPickupText'].items)
        }

        // <<< 今週のピックアップ 動画 >>>
        if (rcv.weeklyPickupMovie != null) {
          const tgt = rcv.weeklyPickupMovie
          this.sectionsData['weeklyPickupMovie'] = {
            label: tgt.label,
            tagId: tgt.tagId,
            type: MENU_SEC_TYPES.def_movie,
            iconType: SEC_ICON_TYPE.movie,
            items: [...tgt.items]
          }
          this.checkMovieContents(this.sectionsData['weeklyPickupMovie'].items)
        }

        // <<< ピックアップ占い師 >>>
        if (rcv.pickupCounselor != null) {
          const tgt = rcv.pickupCounselor
          this.sectionsData['pickupCounselor'] = {
            label: tgt.label,
            tagId: parseInt(tgt.tagId),
            coloredBg: true,
            type: MENU_SEC_TYPES.counselor,
            subtitle: '注目の占い師',
            iconType: SEC_ICON_TYPE.text,
            categoryLink: `/tag/${tgt.tagId}`,
            items: [{
              label: tgt.label,
              menuId: parseInt(tgt.tagId),
              description: tgt.description,
              thumbnail: tgt.thumbnail,
              isRight: false,
              hasMovieLink: false,
            }]
          }
          this.checkMovieContents(this.sectionsData['pickupCounselor'].items)
        }

        // <<< ピックアップ占術 >>>
        if (rcv.pickupFortune != null) {
          const tgt = rcv.pickupFortune
          const info = FORTUNE_INFO[`id${tgt.tagId}`]
          this.sectionsData['pickupFortune'] = {
            label: `#${tgt.label}`, //←これここで#つけてだいじょうぶか？
            tagId: parseInt(tgt.tagId),
            type: MENU_SEC_TYPES.fortune,
            iconType: SEC_ICON_TYPE.text,
            categoryLink: `/tag/${tgt.tagId}`,
            items: [{
              label: tgt.label,
              menuId: parseInt(tgt.tagId),
              description: info != null ? info.description || '' : '',
              thumbnail: info != null ? info.thumbnail || '' : '',
              isRight: true,
              hasMovieLink: +rcv.pickupFortune.hasMovieLink > 0,
            }]
          }
          this.checkMovieContents(this.sectionsData['pickupFortune'].items)
        }

        // <<< 新着メニュー >>>
        if (rcv.newMenu != null) {
          const rtn = []

          for(let key in rcv.newMenu){
            rtn.push({
              ...rcv.newMenu[key],
            })
          }

          rtn.sort((a, b)=>{
            const aDate = new moment(a.openedAt)
            const bDate = new moment(b.openedAt)
            if( aDate.isBefore(bDate) ) return 1;
            if( aDate.isAfter(bDate) ) return -1;
            return 0;
          })
          this.sectionsData['newMenu'] = rtn
        }

        // <<< タグアイテム群 >>>
        if (rcv.__tagItems != null) {
          if (this.sectionsData['__tagItems'] != null) {
            this.sectionsData['__tagItems'].splice(0)
          } else {
            this.sectionsData['__tagItems'] = []
          }
          const tgtlist = this.sectionsData['__tagItems']
          for (let [index, tgt] of rcv.__tagItems.entries()) {
            const ltype = tgt.listType != null ? parseInt(tgt.listType) : 1
            const len = tgtlist.push({
              label: `#${tgt.label}`, //←これここで#つけてだいじょうぶか？
              tagId: parseInt(tgt.tagId),
              isTagItem: true,
              type: ltype === 2 ? MENU_SEC_TYPES.def_movie : MENU_SEC_TYPES.def_text, // 1以外はテキスト
              iconType: ltype === 2 ? SEC_ICON_TYPE.movie : SEC_ICON_TYPE.text, // 1以外はテキスト
              items: [...tgt.items]
            })
            this.checkMovieContents(tgtlist[len - 1].items)
          }
        }
        //console.log('sectionsData: %O  videoSendSrc: %O', this.sectionsData, this.videoSendSrc)
        this.setMovieData()
      }
    },
    setMovieData() {
      //console.log('動画データセット: %O', this.videoSendSrc)
      if(Object.keys(this.videoSendSrc).length > 0) {
        this.$store.dispatch(type.GET_SUBSCRIPT_VIDEO, this.videoSendSrc)
      }
    },
    checkMovieContents(itemList = []) {
      if (itemList.length > 0) {
        for (let item of itemList) {
          if ('videoId' in item && JSON.stringify(item.videoId) !== 'null') {
            this.videoSendSrc[`id${item.videoId}`] = item.videoId
          }
        }
      }
    },
    onLinkClick(url){
      if( url != null && !!this.userProfile && this.userProfile.subscription ){
        const subsc = this.userProfile.subscription
        if( subsc.status === 2) {
          location.href = '/error/suspension'
        }else{
          location.href = url
        }
      }else{
        console.error('ページ遷移ができません')
      }
    }
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.top-base {
  width: 100%;
  padding-bottom: 20px;
  &.has-notification {
    padding-top: 34px;
  }
  &__banner {
    padding: 10px 20px 5px;
    img {
      max-width: 100%;
      vertical-align: middle;
      box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.15);
      border-radius: 10px;
      border-radius: unquote("min(2.667vw, 15.5px)");
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Toppage/MemberTopContents.vue